import {
    Button,
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "frontend-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => Promise<void> | void;
    title: string;
    description: string;
}

export function ConfirmDeleteDialog({
    open,
    onOpenChange,
    onConfirm,
    title,
    description,
}: ConfirmDeleteDialogProps) {
    const { t } = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            await onConfirm();
            onOpenChange(false);
        } catch {
            // keep dialog open on failure
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Dialog
            open={open}
            onOpenChange={(v) => {
                if (!isDeleting) onOpenChange(v);
            }}
        >
            <DialogContent className="bg-compendia-card max-w-md text-compendia-foreground">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <p className="text-body text-compendia-foreground">{description}</p>
                <DialogFooter>
                    <div className="flex justify-end gap-2 w-full">
                        <Button
                            variant="outline"
                            type="button"
                            disabled={isDeleting}
                            onClick={() => onOpenChange(false)}
                        >
                            {t("common.cancel")}
                        </Button>
                        <Button
                            variant="fill"
                            type="button"
                            className="bg-chameleon-pink border-chameleon-pink"
                            disabled={isDeleting}
                            onClick={handleConfirm}
                        >
                            {t("common.delete")}
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
